import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {API} from "../../../../shared/apis/api";
import {CustomActionBarTypeEnum} from "../../../../shared/constants/custom-action-bar-type.enum";
import {HttpMethod} from "../../../../shared/constants/http-method.enum";
import {CommonConstants} from "../../../../shared/constants/common-constants.enum";
import {NavDataService} from "../../../../shared/service/nav-data.service";
import {CustomActionEvent} from "../../../../shared/compoment/action-bar/service/custom-action-event";
import {HttpCustomService} from "../../../../service/http-custom.service";
import {AddInfoModel} from "../../../../shared/model/add-info.model";
import {StationInfoComponent} from "./station-info/station-info.component";
import {Station} from "../../../../shared/model/station";
import {Subject} from "rxjs/Rx";
import * as _ from 'lodash';
import {Cooperative} from "../../../../shared/model/cooperative";

@Component({
  selector: 'omni-station-add',
  templateUrl: './station-add.component.html',
  styleUrls: ['./station-add.component.scss']
})
export class StationAddComponent implements OnInit, OnDestroy, AfterViewInit {
  ngUnsubscribe: Subject<boolean> = new Subject();
  station: Station = {};
  isEdit = false;
  defaultValue: Station = {};
  cooperative: Cooperative;

  @ViewChild(StationInfoComponent, {static: false})
  stationInfoComponent: StationInfoComponent;
  addInfo: AddInfoModel;
  addNewItem: any = {};
  @Output() saveNewChange: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private http: HttpCustomService,
    private csCustomAction: CustomActionEvent,
    private navDataService: NavDataService
  ) {

  }

  ngOnInit(): void {
    this.createAddInfo();
    this.createAddNew();
  }

  ngAfterViewInit(): void {
    _.assign(this.defaultValue, this.stationInfoComponent.formGroup.getRawValue());
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private createAddInfo(): void {
    this.addInfo = {
      isDisableSaveAndNew: this.isEdit,
      title: this.isEdit ? CommonConstants.UPDATE_STATION_LABEL : CommonConstants.CREATE_NEW_STATION_LABEL,
      urlStatement: {path: API.STATION},
      method: this.isEdit ? HttpMethod.PUT : HttpMethod.POST
    }
  }

  private createAddNew(): void {
    this.addNewItem = {
      onSave: (e) => {
        if (e) {
          this.stationInfoComponent.formGroup.reset(this.defaultValue);
          this.saveNewChange.emit(true);
          if (this.isEdit) {
            this.csCustomAction.emitChange({
              type: CustomActionBarTypeEnum.REFRESH,
              value: true,
              actionId: 'station-list'
            });
          }
          this.navDataService.emitRefreshChange(true);
        }
      },
      onSaveClose: (e) => {
        if (e) {
          this.saveNewChange.emit(true);
          if (this.isEdit) {
            this.csCustomAction.emitChange({
              type: CustomActionBarTypeEnum.REFRESH,
              value: true,
              actionId: 'station-list'
            });
          }
          this.navDataService.emitRefreshChange(true);
        }
      }
    }
  }
}

